module.exports = __webpack_public_path__ + "img/kise_yes.48bf1a9c.png";